module.exports = __webpack_public_path__ + "img/searchnotfoundpan.e5cc8221.svg";